import request from '@/utils/request'
import config from '@/config'

export default {
  getDict (params) {
    return request.get(config.ApiYJ + '/Base/dict', { params })
  },
  getCacd (params) {
    return request.get(config.ApiYJ + '/Base/Cacd', { params })
  },
  getBaseAdcd (params) {
    return request.get(config.ApiYJ + '/Base/Adcd', { params })
  },
  getBaseUserAdcd (params) {
    return request.get(config.ApiYJ + '/Base/userAdcd', { params })
  }

}
